import { render, staticRenderFns } from "./relationOrderInfo.vue?vue&type=template&id=4b96aca5&scoped=true"
import script from "./relationOrderInfo.vue?vue&type=script&lang=js"
export * from "./relationOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./relationOrderInfo.vue?vue&type=style&index=0&id=4b96aca5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96aca5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b96aca5')) {
      api.createRecord('4b96aca5', component.options)
    } else {
      api.reload('4b96aca5', component.options)
    }
    module.hot.accept("./relationOrderInfo.vue?vue&type=template&id=4b96aca5&scoped=true", function () {
      api.rerender('4b96aca5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/components/relationOrderInfo.vue"
export default component.exports